import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueMarkdown from 'vue-markdown'
import ReadMore from 'vue-read-more'

Vue.config.productionTip = false
// Vue.use(VueMarkdown)
Vue.use(ReadMore)

new Vue({
  router,
  store,
  components: {
    VueMarkdown,
    ReadMore
  },
  render: h => h(App)
}).$mount('#app')
